import { render, staticRenderFns } from "./template-folder.vue?vue&type=template&id=5aa736f4&"
import script from "./template-folder.vue?vue&type=script&lang=js&"
export * from "./template-folder.vue?vue&type=script&lang=js&"
import style0 from "./template-folder.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports